// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0d291c","white":"#fff","wrapper":"styles_wrapper__sPd11","container":"styles_container__63FXi"};